<template>
  <!-- 关联尾巴 -->
  <div class="tail" @click.stop="gotailUrl">
    <div class="tail-left">
      <img :src="cards.cover | imgZip(80, 80)" alt="" />
    </div>
    <div class="tail-center">
      <div class="tail-title">{{ cards.title }}</div>
      <div class="tail-des">{{ cards.description }}</div>
    </div>
    <div class="tail-right">
      <span class="tail-look">进去看看</span>
      <img
        class="icon-right"
        src="../../../images/platform/topicDetail/icon-right-bule.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cards: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    gotailUrl() {
      this.$emit('gotailurl')
      this.routerPush(this.cards.url)
    }
  }
}
</script>
<style lang="scss" scoped>
.tail {
  width: 626px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px 30px 20px 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  background: #f9f9f9;
  .tail-left {
    width: 80px;
    height: 80px;
    > img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      object-fit: cover;
    }
  }
  .tail-center {
    width: 340px;
    margin-left: 20px;
    .tail-title {
      font-size: 28px;
      font-weight: 600;
      color: #21252d;
      line-height: 1.1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tail-des {
      margin-top: 16px;
      font-size: 24px;
      font-weight: 400;
      color: #6c798c;
      line-height: 1.1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .tail-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 400;
    color: #6982fa;
    line-height: 1.5;
    .icon-right {
      margin-left: 6px;
      width: 14px;
      height: 14px;
    }
  }
}
</style>
